import { useState } from "react";
import { Dropdown, Form, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faSearch,
  faUniversity,
} from "@fortawesome/free-solid-svg-icons";
import { FloatInput } from "src/componentes";
import { obterNomeBancoCompe, tabelaBancosCompe } from "../../MDFe.Dto";
import { FieldError } from "react-hook-form";

interface BancoCompeInputProps {
  registerField: any;
  value?: string | null;
  onChangeValue: (codigo: string) => void;
  errorsMessage?: FieldError | undefined;
  disabled?: boolean;
}

export const BancoCompeInputComponent = ({
  registerField,
  value = "",
  onChangeValue,
  errorsMessage,
  disabled = false,
}: BancoCompeInputProps) => {
  const [termoBusca, setTermoBusca] = useState("");

  const bancosFiltrados = tabelaBancosCompe.filter((b) => {
    if (!termoBusca.trim()) return true;
    const t = termoBusca.toLowerCase().trim();
    return (
      b.codigo.includes(t) ||
      b.nome.toLowerCase().includes(t) ||
      (b.nomeCompleto && b.nomeCompleto.toLowerCase().includes(t))
    );
  });

  const nomeBancoIdentificado = obterNomeBancoCompe(value);

  return (
    <div>
      <InputGroup hasValidation className="d-flex align-items-stretch">
        <div className="flex-grow-1">
          <FloatInput
            label="Código do Banco (COMPE) *"
            inputMask="int"
            maxLength={5}
            registerField={registerField}
            errorsMessage={errorsMessage}
            disabled={disabled}
          />
        </div>

        <Dropdown align="end">
          <Dropdown.Toggle
            variant="outline-primary"
            id="dropdown-banco-compe"
            title="Selecionar Banco na Tabela COMPE"
            className="d-flex align-items-center gap-1 h-100 px-3"
            style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
            disabled={disabled}
          >
            <FontAwesomeIcon icon={faUniversity} />
            <span className="d-none d-sm-inline">Bancos</span>
          </Dropdown.Toggle>

          <Dropdown.Menu
            style={{
              minWidth: "320px",
              maxWidth: "380px",
              maxHeight: "360px",
              overflowY: "auto",
            }}
          >
            <div className="p-2 border-bottom sticky-top bg-body">
              <InputGroup size="sm">
                <InputGroup.Text>
                  <FontAwesomeIcon icon={faSearch} />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Buscar por código ou nome..."
                  value={termoBusca}
                  onChange={(e) => setTermoBusca(e.target.value)}
                  autoFocus
                  onClick={(e) => e.stopPropagation()}
                  onKeyDown={(e) => e.stopPropagation()}
                />
                {termoBusca && (
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    onClick={(e) => {
                      e.stopPropagation();
                      setTermoBusca("");
                    }}
                  >
                    ✕
                  </button>
                )}
              </InputGroup>
            </div>

            {bancosFiltrados.length === 0 ? (
              <div className="p-3 text-muted text-center small">
                Nenhum banco encontrado para "{termoBusca}". Você pode digitar o
                código desejado diretamente no campo.
              </div>
            ) : (
              bancosFiltrados.map((banco) => {
                const isSelected =
                  value === banco.codigo ||
                  value === String(Number(banco.codigo));
                return (
                  <Dropdown.Item
                    key={banco.codigo}
                    active={isSelected}
                    onClick={() => {
                      onChangeValue(banco.codigo);
                      setTermoBusca("");
                    }}
                    className="d-flex justify-content-between align-items-center py-2 px-3 border-bottom border-light"
                  >
                    <div className="text-truncate me-2">
                      <span className="fw-bold font-monospace text-primary me-2">
                        {banco.codigo}
                      </span>
                      <span className="fw-medium">{banco.nome}</span>
                    </div>
                    {isSelected && (
                      <FontAwesomeIcon
                        icon={faCheckCircle}
                        className="text-success ms-2"
                      />
                    )}
                  </Dropdown.Item>
                );
              })
            )}
          </Dropdown.Menu>
        </Dropdown>
      </InputGroup>

      {/* Identificação automática do banco */}
      {nomeBancoIdentificado ? (
        <div className="text-success small mt-1 fw-semibold d-flex align-items-center gap-1">
          <FontAwesomeIcon icon={faCheckCircle} />
          <span>Banco identificado: {nomeBancoIdentificado}</span>
        </div>
      ) : value && value.trim() !== "" ? (
        <div className="text-muted small mt-1">
          Código COMPE customizado informado manualmente (3 a 5 dígitos).
        </div>
      ) : (
        <div className="form-text text-muted small mt-1">
          Selecione no botão "Bancos" ou digite o código de 3 a 5 dígitos (ex:
          001, 237, 104).
        </div>
      )}
    </div>
  );
};

export default BancoCompeInputComponent;
